import { render, staticRenderFns } from "./ArtisanItem.vue?vue&type=template&id=fe4b8820&scoped=true&"
import script from "./ArtisanItem.vue?vue&type=script&lang=js&"
export * from "./ArtisanItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtisanItem.vue?vue&type=style&index=0&id=fe4b8820&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4b8820",
  null
  
)

export default component.exports